import React from 'react';

const EmojiLove = () => (
  <svg
    width="29"
    height="30"
    viewBox="0 0 29 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d)">
      <mask
        id="path-1-outside-1"
        maskUnits="userSpaceOnUse"
        x="1.78027"
        y="0.7677"
        width="25"
        height="29"
        fill="black"
      >
        <rect fill="white" x="1.78027" y="0.7677" width="25" height="29" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1704 6.44279C15.5514 5.30269 15.4356 4.26766 14.807 3.90144C13.9935 3.42754 12.6293 4.25306 11.76 5.74529C11.5004 6.19101 11.3142 6.64579 11.2025 7.07709C6.89721 8.30083 3.75454 12.2494 3.78043 16.9056C3.81157 22.5046 8.41236 27.0067 14.0566 26.9613C19.7008 26.9159 24.2511 22.3403 24.22 16.7413C24.1972 12.6382 21.7203 9.12418 18.1771 7.55724C18.6434 7.14795 18.8714 6.67372 18.7287 6.28451C18.4942 5.64453 17.3463 5.47675 16.1648 5.90978C15.7837 6.04946 15.4456 6.23459 15.1704 6.44279Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1704 6.44279C15.5514 5.30269 15.4356 4.26766 14.807 3.90144C13.9935 3.42754 12.6293 4.25306 11.76 5.74529C11.5004 6.19101 11.3142 6.64579 11.2025 7.07709C6.89721 8.30083 3.75454 12.2494 3.78043 16.9056C3.81157 22.5046 8.41236 27.0067 14.0566 26.9613C19.7008 26.9159 24.2511 22.3403 24.22 16.7413C24.1972 12.6382 21.7203 9.12418 18.1771 7.55724C18.6434 7.14795 18.8714 6.67372 18.7287 6.28451C18.4942 5.64453 17.3463 5.47675 16.1648 5.90978C15.7837 6.04946 15.4456 6.23459 15.1704 6.44279Z"
        fill="#F9F3EB"
      />
      <path
        d="M14.807 3.90144L15.8137 2.1733L14.807 3.90144ZM15.1704 6.44279L13.2735 5.80889C12.9957 6.64035 13.2917 7.55584 14.0037 8.06724C14.7158 8.57863 15.6778 8.56671 16.377 8.03783L15.1704 6.44279ZM11.76 5.74529L10.0319 4.73854L10.0319 4.73854L11.76 5.74529ZM11.2025 7.07709L11.7494 9.00089C12.432 8.80684 12.9607 8.26555 13.1387 7.5785L11.2025 7.07709ZM3.78043 16.9056L1.78046 16.9168L3.78043 16.9056ZM14.0566 26.9613L14.0727 28.9612H14.0727L14.0566 26.9613ZM24.22 16.7413L22.22 16.7524L24.22 16.7413ZM18.1771 7.55724L16.8578 6.05407C16.3447 6.50437 16.0968 7.18525 16.2001 7.86003C16.3035 8.5348 16.7438 9.11026 17.3682 9.38635L18.1771 7.55724ZM18.7287 6.28451L16.8509 6.97276V6.97277L18.7287 6.28451ZM16.1648 5.90978L16.853 7.78762V7.78762L16.1648 5.90978ZM13.8002 5.62958C13.6138 5.52097 13.4984 5.37838 13.4382 5.2711C13.3833 5.17323 13.3813 5.11939 13.385 5.14754C13.3885 5.17337 13.3935 5.24602 13.3782 5.36805C13.3632 5.48787 13.3309 5.63709 13.2735 5.80889L17.0673 7.07669C17.327 6.29943 17.4601 5.44129 17.3496 4.61628C17.2404 3.80171 16.8435 2.77321 15.8137 2.1733L13.8002 5.62958ZM13.4882 6.75203C13.7877 6.23794 14.1262 5.92645 14.3399 5.79716C14.4444 5.7339 14.4572 5.75119 14.3739 5.76228C14.2747 5.77549 14.0485 5.77419 13.8002 5.62958L15.8137 2.1733C14.4776 1.39493 13.0842 1.88168 12.269 2.37498C11.3799 2.91302 10.6017 3.76042 10.0319 4.73854L13.4882 6.75203ZM13.1387 7.5785C13.2018 7.33455 13.3152 7.04897 13.4882 6.75203L10.0319 4.73854C9.68557 5.33304 9.42663 5.95703 9.26642 6.57568L13.1387 7.5785ZM10.6557 5.15329C5.51906 6.61333 1.74939 11.329 1.78046 16.9168L5.7804 16.8945C5.75969 13.1697 8.27535 9.98833 11.7494 9.00089L10.6557 5.15329ZM1.78046 16.9168C1.81784 23.6375 7.33727 29.0154 14.0727 28.9612L14.0405 24.9614C9.48746 24.998 5.8053 21.3718 5.7804 16.8945L1.78046 16.9168ZM14.0727 28.9612C20.8043 28.9071 26.2573 23.4469 26.22 16.7302L22.22 16.7524C22.245 21.2337 18.5973 24.9247 14.0405 24.9614L14.0727 28.9612ZM26.22 16.7302C26.1926 11.8048 23.2174 7.59941 18.986 5.72812L17.3682 9.38635C20.2232 10.6489 22.2018 13.4716 22.22 16.7524L26.22 16.7302ZM19.4963 9.0604C20.1208 8.51234 21.1986 7.2114 20.6066 5.59626L16.8509 6.97277C16.6992 6.55892 16.7986 6.22441 16.8549 6.09821C16.9057 5.98447 16.9393 5.98254 16.8578 6.05407L19.4963 9.0604ZM20.6066 5.59626C20.1169 4.26023 18.8554 3.8275 18.0911 3.71579C17.2382 3.59114 16.3175 3.72369 15.4765 4.03193L16.853 7.78762C17.1935 7.66284 17.4376 7.66277 17.5126 7.67374C17.5476 7.67886 17.4705 7.67515 17.3388 7.59324C17.1934 7.50275 16.9733 7.30687 16.8509 6.97276L20.6066 5.59626ZM15.4765 4.03193C14.9228 4.23488 14.4077 4.51196 13.9638 4.84775L16.377 8.03783C16.4836 7.95721 16.6446 7.86403 16.853 7.78762L15.4765 4.03193Z"
        fill="#F9F3EB"
        mask="url(#path-1-outside-1)"
      />
    </g>
    <ellipse
      rx="10.2201"
      ry="10.138"
      transform="matrix(0.999968 -0.00803993 0.00556109 0.999985 14 16.78)"
      fill="#FFA154"
    />
    <path
      opacity="0.9"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4763 25.643C19.1212 25.5991 23.672 21.1676 23.6408 15.745C23.6328 14.352 23.3232 13.0291 22.7719 11.833C23.716 13.3084 24.2646 15.0437 24.2753 16.9041C24.3064 22.3267 19.7556 26.7582 14.1108 26.8022C9.91595 26.8348 6.29739 24.4353 4.70239 20.9751C6.51016 23.8001 9.76806 25.6719 13.4763 25.643Z"
      fill="#D84C42"
    />
    <ellipse
      rx="2.27841"
      ry="1.23418"
      transform="matrix(0.938923 -0.344128 0.344126 0.938924 16.5896 7.02512)"
      fill="#FFA154"
    />
    <ellipse
      cx="13.2327"
      cy="6.55996"
      rx="3.12696"
      ry="1.70463"
      transform="rotate(-59.7766 13.2327 6.55996)"
      fill="#FFA154"
    />
    <path
      opacity="0.9"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8123 3.82454C15.6258 4.29843 15.5805 5.89229 14.7112 7.38451C14.3079 8.07677 13.7982 8.62555 13.2863 8.96767C13.6042 8.65875 13.9059 8.27451 14.1639 7.83152C15.0333 6.3393 15.0785 4.74544 14.2651 4.27155C13.829 4.01749 13.2346 4.13688 12.6431 4.53224C13.3961 3.80054 14.2404 3.49132 14.8123 3.82454ZM18.2406 6.18199C18.4752 6.82197 17.7075 7.69182 16.5261 8.12484C15.8714 8.36477 15.2271 8.42026 14.7427 8.31317C15.1944 8.67017 16.1183 8.70836 17.0637 8.36186C18.2452 7.92883 19.0128 7.05898 18.7783 6.419C18.6737 6.13361 18.3875 5.94213 17.9976 5.85594C18.1104 5.94509 18.1937 6.05411 18.2406 6.18199Z"
      fill="#D84C42"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.56822 18.2163L9.56542 18.219V18.2136L6.61724 15.3436C5.48785 14.2442 5.83554 12.5564 7.27913 12.1307C8.33404 11.8197 9.50297 12.6031 9.56828 13.6342C9.6335 12.603 10.8025 11.8195 11.8574 12.1306C13.301 12.5563 13.6487 14.244 12.5193 15.3435L9.57115 18.2134V18.2192L9.56822 18.2163Z"
      fill="#C61608"
    />
    <path
      d="M8.39643 14.3252C8.43414 14.7126 7.98729 14.9546 7.68338 14.7114L7.13812 14.275C6.61841 13.8591 6.69551 13.1354 7.2849 12.8974C7.72814 12.7185 8.26957 13.0218 8.31356 13.4738L8.39643 14.3252Z"
      fill="#F9F3EB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4181 18.2163L18.4154 18.2189V18.2136L15.4671 15.3435C14.3377 14.2441 14.6854 12.5563 16.129 12.1306C17.1843 11.8194 18.3537 12.6036 18.4182 13.6353C18.4826 12.6035 19.6521 11.8193 20.7074 12.1305C22.151 12.5562 22.4987 14.2439 21.3693 15.3433L18.421 18.2135V18.2191L18.4181 18.2163Z"
      fill="#C61608"
    />
    <path
      d="M9.44287 19.407H18.5604C18.4338 21.7705 16.4805 23.622 14.1136 23.622H14.0011C11.6377 23.622 9.66392 21.8207 9.44839 19.4672L9.44287 19.407Z"
      fill="#282F33"
    />
    <path
      d="M11.3909 22.1312C11.8081 22.6973 13.0222 23.1149 14.1284 23.1186C16.1588 23.1255 16.8493 22.1312 16.8493 22.1312C16.8493 22.1312 13.9308 19.9889 11.3909 22.1312Z"
      fill="#D84C42"
    />
    <path
      d="M17.2499 14.4735C17.2876 14.8609 16.8408 15.103 16.5369 14.8597L15.9916 14.4234C15.4719 14.0074 15.549 13.2838 16.1384 13.0458C16.5816 12.8668 17.1231 13.1701 17.1671 13.6221L17.2499 14.4735Z"
      fill="#F9F3EB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.04 14.9715C11.2562 15.155 11.2827 15.479 11.0992 15.6952C11.0212 15.7872 10.7287 16.0858 10.4812 16.3384C10.4574 16.3626 10.4338 16.3867 10.4106 16.4104C10.3065 16.5166 10.2089 16.6162 10.1319 16.6953C10.0847 16.7438 10.0468 16.7831 10.0205 16.8107C10.0108 16.8209 10.0037 16.8284 9.99886 16.8336C9.84289 17.0259 9.56615 17.0821 9.34461 16.9548C9.09875 16.8135 9.01398 16.4996 9.15529 16.2537C9.17376 16.2216 9.19222 16.1979 9.19638 16.1926C9.19652 16.1924 9.19665 16.1922 9.19675 16.1921C9.20382 16.183 9.21003 16.1756 9.21383 16.1711C9.22164 16.162 9.22929 16.1535 9.23498 16.1472C9.24686 16.1342 9.26124 16.1189 9.27626 16.1031C9.30684 16.0709 9.34825 16.0281 9.39599 15.979C9.47434 15.8985 9.57367 15.7972 9.67778 15.691C9.70091 15.6674 9.72428 15.6435 9.74771 15.6196C9.87721 15.4875 10.0089 15.353 10.1157 15.2425C10.1692 15.1872 10.2156 15.1389 10.2519 15.1005C10.2701 15.0813 10.285 15.0653 10.2967 15.0525C10.3025 15.0462 10.3071 15.0411 10.3106 15.0371L10.3147 15.0325L10.3159 15.0312L10.3162 15.0308C10.3162 15.0308 10.3163 15.0307 10.3163 15.0307L10.3163 15.0307C10.4998 14.8145 10.8238 14.788 11.04 14.9715Z"
      fill="white"
      fillOpacity="0.6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8581 15.1198C20.0743 15.3033 20.1009 15.6273 19.9174 15.8435C19.8393 15.9355 19.5468 16.2341 19.2993 16.4867C19.2755 16.5109 19.252 16.535 19.2287 16.5587C19.1246 16.6649 19.027 16.7645 18.95 16.8436C18.9028 16.8921 18.8649 16.9313 18.8386 16.9589C18.8289 16.9692 18.8218 16.9767 18.817 16.9819C18.661 17.1742 18.3843 17.2304 18.1627 17.1031C17.9169 16.9618 17.8321 16.6479 17.9734 16.402C17.9919 16.3699 18.0103 16.3462 18.0145 16.3409C18.0146 16.3407 18.0148 16.3405 18.0149 16.3404C18.0219 16.3313 18.0281 16.3239 18.0319 16.3194C18.0398 16.3103 18.0474 16.3018 18.0531 16.2955C18.065 16.2825 18.0794 16.2672 18.0944 16.2514C18.125 16.2192 18.1664 16.1764 18.2141 16.1273C18.2925 16.0468 18.3918 15.9455 18.4959 15.8393C18.519 15.8157 18.5424 15.7919 18.5658 15.7679C18.6953 15.6358 18.827 15.5013 18.9339 15.3908C18.9873 15.3355 19.0337 15.2872 19.07 15.2488C19.0882 15.2296 19.1031 15.2136 19.1148 15.2008C19.1206 15.1945 19.1252 15.1894 19.1287 15.1855L19.1329 15.1808L19.134 15.1795L19.1343 15.1791C19.1344 15.1791 19.1344 15.179 19.1344 15.179L19.1344 15.179C19.3179 14.9628 19.6419 14.9363 19.8581 15.1198Z"
      fill="white"
      fillOpacity="0.6"
    />
    <defs>
      <filter
        id="filter0_d"
        x="0.780273"
        y="0.764893"
        width="28.4399"
        height="31.1967"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default EmojiLove;
